<template>
  <component :is="baseComponent" :to="link.path ? link.path : '/'" :class="{ active: isActive }" tag="li">

    <!-- {{ link }} -->
    <a v-if="isMenu" href="#" class="nav-link sidebar-menu-item" :aria-expanded="!collapsed" data-toggle="collapse"
      @click.prevent="collapseMenu">
      <md-icon v-if="!link.iconPath">{{ link.icon }}</md-icon>
      <md-icon v-if="link.iconPath"
        :md-src="isActive ? require(`../../assets/images/${link.iconPath2}`) : require(`../../assets/images/${link.iconPath}`)"></md-icon>

      <p>
        {{ getName() }}
        <b class="caret"></b>
      </p>
      <md-tooltip v-if="getflagtooltip.length > 0">
        {{ getflagtooltip }}
      </md-tooltip>
    </a>

    <collapse-transition>
      <div v-if="$slots.default || this.isMenu" v-show="!collapsed">
        <ul class="nav">
          <slot></slot>
        </ul>
      </div>
    </collapse-transition>

    <slot name="title" v-if="children.length === 0 && !$slots.default && link.path">
      <component :to="link.path" @click.native="linkClick" :is="elementType(link, false)" :class="{ active: link.active }"
        class="nav-link d-flex" :target="link.target" :href="link.path">
        <template v-if="addLink">
          <span class="sidebar-mini">
            <md-icon v-if="!link.iconPath">{{ link.icon }}</md-icon>
            <md-icon v-if="link.iconPath"
              :md-src="isActive ? require(`../../assets/images/${link.iconPath2}`) : require(`../../assets/images/${link.iconPath}`)"></md-icon>


          </span>
          <span class="sidebar-normal">{{ link.name }}</span>
        </template>
        <template v-else>
          <md-icon v-if="!link.iconPath">{{ link.icon }}</md-icon>
          <md-icon v-if="link.iconPath"
            :md-src="isActive ? require(`../../assets/images/${link.iconPath2}`) : require(`../../assets/images/${link.iconPath}`)"></md-icon>


          <p>{{ link.name }}</p>
        </template>
      </component>
    </slot>
  </component>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";

export default {
  name: "sidebar-item",
  components: {
    CollapseTransition,
  },
  props: {
    menu: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: "",
          children: [],
        };
      },
    },
  },

  provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild,
    };
  },
  inject: {
    addLink: { default: null },
    removeLink: { default: null },
    autoClose: {
      default: true,
    },
  },
  data() {
    return {
      children: [],
      collapsed: true,
    };
  },
  computed: {
    getflagtooltip() {
      let rlt = "";
      if (this.link.name.length > 18) {
        rlt = this.link.name;
      }
      return rlt;
    },
    baseComponent() {
      return this.isMenu || this.link.isRoute ? "li" : "router-link";
    },
    linkPrefix() {
      if (this.link.name) {
        let words = this.link.name.split(" ");
        return words.map((word) => word.substring(0, 1)).join("");
      }
      return false;
    },
    isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive() {
      if (this.$route.path.indexOf(this.link.path) > -1) return true;
      if (this.$route && this.$route.path) {
        let matchingRoute = this.children.find((c) => {
          this.$route.path.startsWith(c.link.path);
        });
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    setSchoolId() {
      this.$store.commit("setSchoolId", this.link.school_id);
    },
    getName() {
      let rlt = this.link.name;
      if (rlt.length > 18) {
        rlt = rlt.substring(0, 18);
        rlt = rlt + "...";
      }
      return rlt;
    },
    addChild(item) {
      const index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild(item) {
      const tabs = this.children;
      const index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType(link, isParent = true) {
      if (link.isRoute === false) {
        return isParent ? "li" : "a";
      } else {
        return "router-link";
      }
    },
    linkAbbreviation(name) {
      const matches = name.match(/\b(\w)/g);
      return matches.join("");
    },
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
    collapseMenu() {
      // this.setSchoolId();
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    },
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  },
};
</script>
<style scoped>
.sidebar-menu-item {
  cursor: pointer;
}

.sidbar-icon {
  color: #606a76;
  margin-right: 20px;
}

.nav {
  display: block !important;
}

.md-tooltip {
  z-index: 100000;
}

.nav-link {
  display: flex;
  align-items: center;
}</style>
